import React, { useState } from "react";

const CustomerClubContext = React.createContext({
  editScoreItem: {},
  setEditScoreItem: (state) => {},
});

export default CustomerClubContext;

export const CustomerClubContextProvider = ({ children }) => {
  const [editScoreItem, setEditScoreItem] = useState({});

  return (
    <CustomerClubContext.Provider
      value={{
        editScoreItem,
        setEditScoreItem,
      }}
    >
      {children}
    </CustomerClubContext.Provider>
  );
};
